<template>
  <button class="v-button" 
    :class="{'is-disabled': disabled}"
    type="button"
    @click="onClick">
    <span><slot></slot></span>
  </button>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onClick(e) {
        this.$emit('click');
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/scss/px2rem.scss";
  
  .v-button {
    &.is-disabled {
      pointer-events: none;
      background: #ccc;
    }
    &:active {
      background: #4974F1;
    }
    border: none;
    width: 100%;
    border-radius: px2rem(6);
    font-size: px2rem(36);
    height: px2rem(100);
    background: #4D7BFE;
    color: #fff;
    white-space: nowrap;
    span {
      vertical-align: middle;
      line-height: normal;
    }
  }
</style>